export enum EventStatus {
  INPROCESS = 'InProcess',
  PUBLISHED = 'Published',
  DELETED = 'Deleted'
}
